import React, { Component, Fragment } from "react";
import GeneralButton from "../generalButton";
import ProblemDescription from "../problemDescription";
import UploadVoucher from "../uploadVoucher";
import error from "../../static/images/error.png";
import success from "../../static/images/success.png";
import styles from "./index.less";
const getQueryString = (name: string) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
      return unescape(r[2]);
  }
  return "undefined";
}
interface Props {
  bouncedText?: string;
  needImg?: boolean;
  type?: string;
  modalType?: boolean;
  confirm?: () => void;
  cancelBounced?: () => void;
  goBack?: () => void;
  getValue?: (value: any, type: string) => void;
  changSubmitStatus?:(status:boolean)=>void;
  buttonLeft?: string;
  buttonRight?: string;
  errorTip?: string;
  docTip?:string;
  typeBounced?: string;
}

interface State {}

class Bounced extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  additionalInformation = () => {
    const {
      getValue,
      confirm,
      cancelBounced,
      buttonLeft,
      buttonRight,
      errorTip,
      docTip,
      modalType,
      changSubmitStatus 
    } = this.props;
    return (
      <div className={styles.additionalInformation}>
        <div className={styles.title}>补充资料</div>
        <ProblemDescription
          labelName="申诉描述"
          fieldName="description"
          placeholder="请详细描述您的问题（200字以内）"
          maxSize={200}
          getValue={getValue}
          errorTip={errorTip}
          is_required={true}
          source="bounced"
        />
        <UploadVoucher
          labelName="上传附件"
          fieldName="picUrl"
          maxSize={9}
          reference={true}
          getValue={getValue}
          modalType={modalType}
          errorTip={docTip}
          is_required={true}
          source="bounced"
          showTips={'注：支持png、jpg、jpeg、mp4、mov、avi、doc、docx，pdf、rar、zip格式，每个文件不能大于50M'}
          changSubmitStatus={changSubmitStatus}
        />
        <div className={styles.button}>
          <GeneralButton
            buttonText={buttonLeft}
            type="small"
            styleColor="activation"
            buttonClick={confirm}
          />
          <GeneralButton
            buttonText={buttonRight}
            type="small"
            styleColor="unactivation"
            buttonClick={cancelBounced}
          />
        </div>
        <img src={error} className={styles.error} onClick={cancelBounced}></img>
      </div>
    );
  };
  goReload = ()=>{
    window.location.href=`https://appealcenter.58.com/case/home/appealspentrance?spTemplateId=${getQueryString('spTemplateId')}&ss-fro-3`
  }
  render() {
    const {
      bouncedText,
      type,
      needImg,
      cancelBounced,
      buttonLeft,
      buttonRight,
      confirm,
      typeBounced,
    } = this.props;
    return type === "additionalInfo" ? (
      this.additionalInformation()
    ) : (
      <div className={styles.bounced}>
        {getQueryString('spTemplateId')?<div style={{textAlign:'right',fontSize:'21px',marginTop:'-35px'}} onClick={this.goReload}>x</div>:""}
        {needImg ? <img src={success} className={styles.success} /> : null}
        {needImg ? (
          <div className={styles.needImgContent}>
            <div>{bouncedText.slice(0, 9)}</div>
            <div>{bouncedText.slice(10, bouncedText.length)}</div>
          </div>
        ) : (
        <div className={styles.content}>{bouncedText}</div>
        )}
        {typeBounced === "spentrance" ? null : (
          <Fragment>
            <div className={styles.button}>
              <GeneralButton
                buttonText={buttonLeft}
                type="small"
                styleColor="unactivation"
                buttonClick={cancelBounced}
              />
              <GeneralButton
                buttonText={buttonRight}
                type="small"
                styleColor="activation"
                buttonClick={confirm}
              />
            </div>
            <img
              src={error}
              className={styles.error}
              onClick={cancelBounced}
            ></img>
          </Fragment>
        )}
      </div>
    );
  }
}

export default Bounced;
